import { Component, OnInit } from '@angular/core';
import { ModalConfig, ModalService } from '@freelancer/ui';

import { AwardModalComponent } from 'app/projects/award-modal/award-modal.component';

export const MODALS_MAP = {
  AwardModalComponent,
};

@Component({
  selector: 'webapp-compat-modals',
  template: `
    <fl-modal></fl-modal>
  `,
})
export class CompatModalsComponent implements OnInit {
  constructor(private modalService: ModalService) {}

  ngOnInit() {
    const w = <any>window;
    w.webappCompatModals = {
      open: (componentName: keyof typeof MODALS_MAP, config: ModalConfig) =>
        this.modalService.open(MODALS_MAP[componentName], config),
    };
    if (w.webappCompatModalsReadyCallback) {
      w.webappCompatModalsReadyCallback();
    }
  }
}



// WEBPACK FOOTER //
// ./src/compat/compat-modals.component.ts